import { render, staticRenderFns } from "./TodoListView.vue?vue&type=template&id=0eba0850&"
import script from "./TodoListView.vue?vue&type=script&lang=js&"
export * from "./TodoListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports